// keep sync with backend
export enum SystemPermission {
  // Setting
  MANAGE_PERMISSION = 'setting:managePermission',

  // Role
  ASSIGN_ROLE = 'role:assignUser',

  // Safety Monitoring
  SAFETY_MONITORING = 'role:safetyMonitoring',

  // De-identified Data
  DEIDENTIFIED_DATA = 'role:deidentifiedData',

  // Team
  MANAGE_TEAM = 'team:manageTeam',
  ASSIGN_TEAM = 'team:assignTeam',

  // Task
  MANAGE_TASK = 'task:manageTask',
  ASSIGN_TASK = 'task:assignTask',

  // Medicine
  MANAGE_MEDICINE_CATALOG = 'medicine:manageMedicineCatalog',
  VIEW_MEDICINE_CATALOG = 'medicine:viewMedicineCatalog',

  // Patient
  EDIT_PATIENT = 'patient:editPatient',
  EDIT_INSIGHT = 'patient:editInsight',
  ASSIGN_PATIENT_TO_OTHER = 'patient:assignPatientToOther',
  VIEW_PATIENT_LIST = 'patient:viewList',
  VIEW_PATIENT_RECORD = 'patient:viewRecord',

  // MedicationProfile
  EDIT_MEDICATION_PROFILE = 'medicationProfile:editMedicationProfile',
  VIEW_MEDICATION_PROFILE = 'medicationProfile:viewMedicationProfile',

  // Feedback
  ADD_FEEDBACK = 'feedback:addFeedback',
  ADD_FEEDBACK_V2 = 'feedback:addFeedbackV2',
}
